"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[837],{

/***/ 8870:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6139);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_icon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7627);





var accordionAnim = {
    open: {
        opacity: 1,
        height: "auto"
    },
    closed: {
        opacity: 0,
        height: 0
    }
};
var Accordion = function(param) {
    var id = param.id, title = param.title, _tooltip = param.tooltip, tooltip = _tooltip === void 0 ? false : _tooltip, _isOpen = param.isOpen, isOpen = _isOpen === void 0 ? false : _isOpen, _style = param.style, style = _style === void 0 ? "default" : _style, _isControlled = param.isControlled, isControlled = _isControlled === void 0 ? false : _isControlled, _onToggle = param.onToggle, onToggle = _onToggle === void 0 ? function() {} : _onToggle, className = param.className, children = param.children, _value = param.value, value = _value === void 0 ? false : _value;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(isOpen), hasFocus = ref[0], setHasFocus = ref[1];
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("accordion", className),
        children: [
            !isControlled && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                onClick: function() {
                    return onToggle(id, !isOpen);
                },
                "aria-expanded": isOpen,
                "aria-controls": "accordion-".concat(id),
                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("accordion--toggle type--h-sm flex w-full text-left items-center", "p-5", "mb-2", "rounded-[3px]", {
                    "border-t px-0 uppercase mb-0 rounded-t-none": style == "mobile-alt",
                    "bg-white": style == "default",
                    "is-open": isOpen,
                    "bg-yellow": isOpen && style !== "mobile-alt"
                }),
                children: [
                    title,
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("accordion--icon", "inline-flex", "items-center", "transition-transform", "md:ml-auto", "relative", "top-[-2px]", "w-[20px]", "h-[20px]", "md:w-[28px]", "md:h-[28px]", {
                            "rotate-45": isOpen,
                            "ml-auto": !value
                        }),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_icon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            name: "AccordionIcon",
                            id: "-".concat(id),
                            viewBox: "0 0 28 28",
                            color: "#000000",
                            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("w-[28px]")
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_4__.m.div, {
                id: "accordion-".concat(id),
                className: "accordion--content",
                initial: isOpen ? "open" : "closed",
                animate: isOpen ? "open" : "closed",
                variants: accordionAnim,
                transition: {
                    duration: 0.5,
                    ease: [
                        0.19,
                        1,
                        0.22,
                        1
                    ]
                },
                onAnimationComplete: function(v) {
                    return setHasFocus(v === "open");
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("accordion--inner", "type--base", "pt-1", "pb-5", "md:pb-3"),
                    hidden: !isOpen && !hasFocus,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        children: children
                    })
                })
            })
        ]
    }, id));
};
/* harmony default export */ __webpack_exports__["Z"] = (Accordion);


/***/ }),

/***/ 9634:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_photo__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(727);




var Media = function(param) {
    var media = param.media, layout = param.layout, _aspect = param.aspect, aspect = _aspect === void 0 ? false : _aspect;
    if (!media) return null;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("media-wrap", {
            "mx-auto": media.maxWidth
        }),
        style: {
            maxWidth: media.maxWidth ? media.maxWidth : "none"
        },
        children: media.photo && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_photo__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            photo: media.photo,
            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("relative", {
                "aspect-video": aspect == "video",
                "aspect-square": aspect == "square"
            }),
            width: 2200,
            layout: layout
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Media);


/***/ }),

/***/ 5837:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(6513);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(6139);
/* harmony import */ var react_cool_inview__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5276);
/* harmony import */ var _components_icon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7627);
/* harmony import */ var _components_photo__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(727);
/* harmony import */ var _components_phrase__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1995);
/* harmony import */ var _components_accordion__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8870);
/* harmony import */ var _components_media__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(9634);










function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var FeatureCarousel = function(param1) {
    var _data = param1.data, data = _data === void 0 ? {} : _data;
    var phrase = data.phrase, slides = data.slides;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), currentSlide = ref[0], setCurrentSlide = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(slides.length - 1), numSlides = ref1[0], setNumSlides = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([
        "carousel-dropdown-0", 
    ]), activeAccordions = ref2[0], setActiveAccordions = ref2[1];
    var buttonVariants = {
        hidden: {
            opacity: 0,
            y: "25px",
            transition: {
                duration: 0.25,
                ease: "easeOut"
            }
        },
        visible: {
            opacity: 1,
            y: 0,
            transition: {
                duration: 0.25,
                ease: "easeOut"
            }
        }
    };
    var buttonContainerVariants = {
        hidden: {
            opacity: 0,
            transition: {
                staggerChildren: 0.25,
                ease: "easeOut"
            }
        },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.25,
                ease: "easeOut"
            }
        }
    };
    var titleVariants = {
        hidden: {
            opacity: 0,
            y: "100px",
            transition: {
                duration: 1,
                ease: "easeOut"
            }
        },
        visible: {
            opacity: 1,
            y: 0,
            transition: {
                duration: 1,
                ease: "easeOut"
            }
        }
    };
    var controls = (0,framer_motion__WEBPACK_IMPORTED_MODULE_9__/* .useAnimation */ ._)();
    var ref3 = (0,react_cool_inview__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)({
        rootMargin: "-100px 0px",
        threshold: [
            0.2,
            0.4,
            0.6
        ],
        onEnter: function(param) {
            var scrollDirection = param.scrollDirection;
            controls.start("visible");
        }
    }, [
        controls
    ]), observe = ref3.observe, unobserve = ref3.unobserve, inView = ref3.inView, scrollDirection = ref3.scrollDirection, entry = ref3.entry;
    var onToggle = function(id, status) {
        if (activeAccordions.includes(id)) {
            setActiveAccordions(activeAccordions.filter(function(item) {
                return item !== id;
            }));
        } else {
            setActiveAccordions(_toConsumableArray(activeAccordions).concat([
                id
            ]));
        }
    };
    var moveCarousel = function(direction) {
        if (direction == "next") {
            currentSlide = currentSlide + 1;
            if (currentSlide > numSlides) {
                currentSlide = 0;
            }
        } else {
            currentSlide = currentSlide - 1;
            if (currentSlide < 0) {
                currentSlide = numSlides;
            }
        }
        setCurrentSlide(currentSlide);
    };
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("feature-carousel"),
        ref: observe,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("grid", "px-gutter", "md:hidden", "site-container"),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "text-lg-1-mobile md:text-lg-1 md:pl-1",
                    children: phrase
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("px-gutter", "hidden", "md:grid", "md:mb-[100px]", "site-container"),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_10__.m.div, {
                    variants: titleVariants,
                    initial: "hidden",
                    animate: controls,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "text-lg-1-mobile md:text-lg-1 md:pl-1",
                        children: phrase
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("grid", "px-gutter", "md:px-5", "pt-10", "pb-3", "site-container"),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("expanders", "block", "md:hidden"),
                        children: slides.map(function(slide, idx) {
                            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_accordion__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                style: "mobile-alt",
                                title: slide.slideLabel,
                                id: "carousel-dropdown-".concat(idx),
                                isOpen: activeAccordions.includes("carousel-dropdown-".concat(idx)),
                                onToggle: onToggle,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("text-large"),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("aspect-square", "md:aspect-video", "relative", "overflow-hidden", "mb-4"),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_media__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                                media: slide.media,
                                                aspect: "square",
                                                layout: "fill"
                                            })
                                        }),
                                        slide.slideBody
                                    ]
                                })
                            }, idx);
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_10__.m.div, {
                        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("slide-nav", "hidden", "md:block"),
                        variants: buttonContainerVariants,
                        initial: "hidden",
                        animate: controls,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            children: slides.map(function(param, idx) {
                                var slideLabel = param.slideLabel;
                                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_10__.m.div, {
                                    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("inline-flex", "mr-6"),
                                    variants: buttonVariants,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("text-caption", "md:text-subheader-2", "uppercase", "relative", "font-sansRegular", {
                                            "opacity-50": currentSlide !== idx
                                        }),
                                        onClick: function() {
                                            return setCurrentSlide(idx);
                                        },
                                        children: [
                                            slideLabel,
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("border-t", "absolute", "bottom-[-2px]", "left-0", "transition-all", {
                                                    "w-full": currentSlide == idx,
                                                    "w-0": currentSlide !== idx
                                                })
                                            })
                                        ]
                                    })
                                }, idx);
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("slides", "hidden", "md:block", "site-container"),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("card", "m-2"),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("grid", "p-1", "grid-cols-1", "md:grid-cols-20", "bg-white", "w-full", "rounded-[3px]"),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("col-span-9", "flex", "flex-col", "p-2"),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("text-large", "font-sansRegular", "tracking-[0.01em]", "leading-[1.3]", "mb-10", "md:mb-0", "max-w-[67%]"),
                                        children: slides[currentSlide].slideBody
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("carousel-controls", "mt-auto"),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("w-[64px]", "mr-3"),
                                                onClick: function() {
                                                    return moveCarousel("prev");
                                                },
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_icon__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                    name: "CarouselLeft",
                                                    viewBox: "0 0 64 64",
                                                    color: "#292929"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("w-[64px]"),
                                                onClick: function() {
                                                    return moveCarousel("next");
                                                },
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_icon__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                    name: "CarouselRight",
                                                    viewBox: "0 0 64 64",
                                                    color: "#292929"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("col-span-11"),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("aspect-video", "relative"),
                                    children: slides.map(function(slide, idx) {
                                        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("absolute", "top-0", "left-0", "w-full", "h-full", "transition-opacity", {
                                                "opacity-0": currentSlide !== idx,
                                                "opacity-100": currentSlide == idx
                                            }),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_media__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                                media: slide.media,
                                                aspect: "video",
                                                layout: "fill"
                                            })
                                        }, idx);
                                    })
                                })
                            })
                        ]
                    })
                })
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["default"] = (FeatureCarousel);


/***/ })

}]);